import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/translation/page.tsx");
